export default {
  state: () => ({
    memberInfo: {},
    identity: {
      isLogin: false,
      isAdmin: false,
      isAuthor: false,
    },
    isGetMemberInfo: false, // 是否有呼叫取得會員資料
  }),
  getters: {
    memberInfo(state) {
      return state.memberInfo;
    },

    identity(state) {
      return state.identity;
    },

    isGetMemberInfo(state) {
      return state.isGetMemberInfo;
    },
  },
  mutations: {
    UPDATE_MEMBER_INFO(state, payload) {
      state.memberInfo = payload.memberInfo;
    },

    UPDATE_IS_GET_MEMBERINFO(state, payload) {
      state.isGetMemberInfo = payload.isGetMemberInfo;
    },

    UPDATE_IDENTITY(state, payload) {
      state.identity = payload.identity;
    },
  },
  actions: {
    updateMemberInfo({ commit }, payload) {
      commit('UPDATE_MEMBER_INFO', payload);
    },

    updateisGetMemberInfo({ commit }, payload) {
      commit('UPDATE_IS_GET_MEMBERINFO', payload);
    },

    updateIdentity({ commit }, payload) {
      commit('UPDATE_IDENTITY', payload);
    },
  },
};
